export const PAYMENT_CHANGE = "PAYMENT_CHANGE";
export const RESET_SAVED_CARD = "RESET_SAVED_CARD";
export const CURRENCY_CODE = "CURRENCY_CODE";
export const TOTAL_AMOUNT_FOR_PAYMENT = "TOTAL_AMOUNT_FOR_PAYMENT";
export const COUNTRY_ID = "COUNTRY_ID";
